import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { themes, activeTheme } from './theme/index';
import { applyTheme } from './theme/applyTheme';

// Respect a user-saved theme from the ThemeSwitcher; fall back to activeTheme.
const savedKey = localStorage.getItem('campusxl-theme');
applyTheme((savedKey && themes[savedKey]) || themes[activeTheme]);

window.history.scrollRestoration = 'manual';
window.scrollTo(0, 0);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
